// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid[data-v-2f30c6ad]{display:grid;margin:.521vw auto;grid-gap:.521vw;border:none}.one-column[data-v-2f30c6ad]{grid-template-columns:100%}", ""]);
// Exports
module.exports = exports;
